// extracted by mini-css-extract-plugin
module.exports = {"mobileGetAccessLink":"MobileGetAccessLink_mobileGetAccessLink__1iIph","text":"MobileGetAccessLink_text__35tjT"};